import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sv-brand-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './brand-header.component.html',
  styleUrls: ['./brand-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandHeaderComponent {
}
